import React from 'react';

export function SalaryIcon() {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5002 7.8335V2.00016L2.50016 2.00016L2.50016 10.3335L10.8335 10.3335V12.0002H0.833496V0.333496H19.1668L19.1668 7.8335H17.5002Z" fill="black" />
      <path d="M12.5002 6.16713C12.5002 7.54785 11.3809 8.66713 10.0002 8.66713C8.61945 8.66713 7.50016 7.54785 7.50016 6.16713C7.50016 4.78642 8.61945 3.66713 10.0002 3.66713C11.3809 3.66713 12.5002 4.78642 12.5002 6.16713ZM10.0229 7.00016H10.8333V6.18573L10.8335 6.16713L10.8333 6.14854V5.3335H9.16663V7.00016H9.97739C9.98496 7.00037 9.99255 7.00047 10.0002 7.00047C10.0078 7.00047 10.0154 7.00037 10.0229 7.00016Z" fill="black" />
      <path d="M19.1668 12.9492V10.754L16.6669 12.8969V8.66683H15.0002L15.0002 12.8969L12.5002 10.754V12.9491L15.2912 15.3414C15.6033 15.6089 16.0638 15.6089 16.3759 15.3414L19.1668 12.9492Z" fill="black" />
    </svg>

  );
}
